"use strict";
exports.__esModule = true;
var stripAccents = function (str) {
    var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    var fixes = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
    var split = accents.split('').join('|');
    var reg = new RegExp("(" + split + ")", 'g');
    function replacement(a) {
        return fixes[accents.indexOf(a)] || '';
    }
    return str.replace(reg, replacement).toLowerCase();
};
var harmonize = function (text) { return stripAccents(text)
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z-]/g, ''); };
var slugify = function (node) {
    // undefined, null, boolean
    if (!node || typeof node === 'boolean') {
        return '';
    }
    // string, number
    if (typeof node === 'string')
        return harmonize(node);
    if (typeof node === 'number')
        return String(node);
    // empty object
    if (typeof node === 'object' && Object.keys(node).length === 0) {
        return '';
    }
    // We did the check about empty object before
    // const castedNode = node as React.ReactElement<any> | React.ReactNodeArray | React.ReactPortal;
    // ReactPortal
    if ('children' in node) {
        return slugify(node.children);
    }
    // ReactNodeArray
    if (node instanceof Array) {
        return node.map(function (n) { return slugify(n); }).join('-');
    }
    // ReactElement
    if ('type' in node)
        return slugify(node.props.children);
    // unhandled case
    return '';
};
exports["default"] = slugify;
//# sourceMappingURL=slugify.js.map